<div class="container-fluid px-4 mt-4 mb-5" *ngIf="dataId > 0">
    <div class="cp-page-header mb-3">
        <div class="cp-page-title">
            <i class="fa-solid fa-building me-2"></i>{{ facility?.name }}
        </div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Inicio</a></li>
                <li class="breadcrumb-item active">Vista de instalación</li>
            </ol>
        </nav>
    </div>

    <ul class="nav nav-pills cp-tabs mb-4">
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeView === 'control-ingreso'" (click)="setActiveView('control-ingreso')" href="javascript:void(0);">
                <i class="fa-solid fa-person-military-pointing me-1"></i>Registros de Ingreso
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeView === 'control-acceso'" (click)="setActiveView('control-acceso')" href="javascript:void(0);">
                <i class="fa-solid fa-person-military-pointing me-1"></i>Control de Acceso
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeView === 'control-rondas'" (click)="setActiveView('control-rondas')" href="javascript:void(0);">
                <i class="fa-solid fa-eye me-1"></i>Registro de Rondas
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeView === 'dependencias'" (click)="setActiveView('dependencias')" href="javascript:void(0);">
                <i class="fa-solid fa-house-flag me-1"></i>Dependencias
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeView === 'informacion'" (click)="setActiveView('informacion')" href="javascript:void(0);">
                <i class="fa-solid fa-house-circle-exclamation me-1"></i>Información
            </a>
        </li>
    </ul>

    <!-- Contenido -->
    <div class="row">
        <div class="col-12">
            <!-- Control de Ingreso -->
            <div class="content-card" *ngIf="activeView === 'control-ingreso'">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title mb-0">
                            <i class="fa-solid fa-person-military-pointing me-2"></i>
                            Control de Ingreso
                        </h5>
                    </div>
                    <div class="card-body">
                        <app-list-controls-facility [facilityId]="dataId"></app-list-controls-facility>
                    </div>
                </div>
            </div>

            <!-- Control de Acceso -->
            <div class="content-card" *ngIf="activeView === 'control-acceso'">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title mb-0">
                            <i class="fa-solid fa-shield-halved me-2"></i>
                            Control de Acceso
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-info">
                            <i class="fa-solid fa-circle-info me-2"></i>
                            No hay datos de control de acceso disponibles para esta instalación.
                        </div>
                    </div>
                </div>
            </div>

            <!-- Control Rondas -->
            <div class="content-card" *ngIf="activeView === 'control-rondas'">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title mb-0">
                            <i class="fa-solid fa-eye me-2"></i>
                            Control de Rondas
                        </h5>
                    </div>
                    <div class="card-body">
                        <app-list-rounds-facility [facilityId]="dataId"></app-list-rounds-facility>
                    </div>
                </div>
            </div>

            <!-- Dependencias -->
            <div class="content-card" *ngIf="activeView === 'dependencias'">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title mb-0">
                            <i class="fa-solid fa-house-flag me-2"></i>
                            Dependencias
                        </h5>
                    </div>
                    <div class="card-body">
                        <app-list-stores-facility [facilityId]="dataId"></app-list-stores-facility>
                    </div>
                </div>
            </div>

            <!-- Información de la Instalación -->
            <div class="content-card" *ngIf="activeView === 'informacion'">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">
                            <i class="fa-solid fa-house-circle-exclamation me-2"></i>
                            Información de la Instalación
                        </h5>
                        <div class="btn-group btn-group-sm">
                            <button *ngIf="!isEditing" class="btn btn-outline-primary" (click)="toggleEdit()"
                                type="button">
                                <i class="fa fa-pencil me-1"></i> Editar
                            </button>
                            <button *ngIf="isEditing" class="btn btn-success" (click)="saveInfo()"
                                type="button">
                                <i class="fa-solid fa-floppy-disk me-1"></i> Guardar
                            </button>
                            <button *ngIf="isEditing" class="btn btn-outline-secondary" (click)="toggleEdit()"
                                type="button">
                                Cancelar
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <form novalidate [formGroup]="form">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Razón Social</label>
                                    <input type="text" class="form-control" formControlName="name"
                                        placeholder="Máximo 50 caracteres">
                                </div>

                                <div class="col-md-8 mb-3">
                                    <label class="form-label">RUT</label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="fa-solid fa-id-card"></i>
                                        </span>
                                        <input (keyup)="onFormatRut($event)" type="text" class="form-control"
                                            formControlName="rut">
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Giro</label>
                                    <input type="text" class="form-control" formControlName="turn">
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label">Ubicación</label>
                                    <input type="text" class="form-control" formControlName="location">
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label">Propietario/Gerente</label>
                                    <input type="text" class="form-control" formControlName="owner"
                                        placeholder="Máximo 50 caracteres">
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Teléfono Propietario/Gerente</label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="fa-solid fa-phone"></i>
                                        </span>
                                        <input type="text" class="form-control" formControlName="owner_phone">
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Email</label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="fa-regular fa-envelope"></i>
                                        </span>
                                        <input type="email" class="form-control" formControlName="email"
                                            placeholder="Email de contacto">
                                    </div>
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Teléfono</label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="fa-solid fa-phone"></i>
                                        </span>
                                        <input type="text" class="form-control" formControlName="phone"
                                            placeholder="Teléfono de contacto">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<ng-template #addFacility let-c="close" let-d="dismiss">
    <div class="modal-body">
        <app-add-facility [refModal]="modalRef"
            (success)="getFacility(); form.get('facility_id')?.setValue($event)"></app-add-facility>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="d('Cross click')">
            Cancelar
        </button>
    </div>
</ng-template>